<template>
    <Tab :style="cssVars" @dimensions_changed="d => landscape = d.orientation === 'landscape' || d.width >= 800">
        <div class="wraper grid">
            <section class="content text-w">
                <h2>Рекламні конструкції</h2>
                <p>
                На цій карті можна знайти інформацію про рекламні конструкції та їхніх власників. Пересвідчитись, чи законно встановлена конструкція в певному місці, чи не порушені терміни її розміщення, тип, розмір та інші технічні характеристики.  
                </p>
            </section>

            <section class="informer-stripe full-width grid interactive-bg">
                <div class="content topchart-section">
                    <h5>Топ власників рекламних конструкцій</h5>
                    <top-chart v-if="top_data" :data='top_data'></top-chart>
                </div>
            </section>

            <section v-if="!landscape" class="full-width grid interactive-bg">
                <rotate-your-phone class="content text-w"/>
            </section>
            
            <template v-else>
            <section class="informer-stripe full-width grid interactive-bg">
                <div class="content">
                    <info-spoiler>
                        <template v-slot:caption>
                            <img src="../assets/backhand_finger_down.png" style="width: 2em; vertical-align: middle;" /> <h6> Як користуватись картою? </h6>
                        </template>
                        <div class="fucking-text">
<p>На карті відображені рекламні конструкції. Сині точки – конструкції, що мають дозвільні документи, фіолетові – які мають прострочені дозволи на розміщення і мають бути демонтовані.</p>
<p>Якщо натиснути на точку праворуч від карти, ви знайдете перелік усіх рекламних засобів цього власника та кількість чинних та прострочених дозволів на їх розміщення.</p>
<p>Під картою розміщена інформація щодо рекламного засобу: про власника (якщо натиснути на код ЄДРПОУ, можна перевірити детальну інформацію на Opendatabot), адреса й точне місце розміщення, термін дії договору, статус, тип, площа та фотографія (фото можно збільшити, клікнувши на нього).</p>

                        </div>
                    </info-spoiler>
                </div>
            </section>

            <section class="full-width map-and-filters">
                <div class="map-container">
                    <div class="map-loading" v-if="!points"> <p>Завантаження ...</p> </div>
                    
                    <points-map v-else
                        :points='map_data'                
                        :points_style="points_style"
                        ref="adsmapref"
                        @point-selected="change_point_selected"
                        :selected_point="selected_point"
                        :address_search_index="address_search_index"
                    />
                </div>
                
                <div class="filters-container">
                    <p class="small-margin-bottom">Дозволи на розміщення рекламних конструкцій:</p>

                    <div class="buttons" v-if="stats">
                        <div><div class="check-legend" style="background-color: var(--col-active);"/> <checkbox v-model="show_active"/><span class="tiny-text"> Чинні <span class="count">({{ stats.get(true) }})</span></span></div>
                        <div><div class="check-legend" style="background-color: var(--col-inactive);"/> <checkbox v-model="show_inactive"/><span class="tiny-text"> Прострочені <span class="count">({{ stats.get(false) }})</span></span></div>
                    </div>

                    <section class="collapsible-buttons" v-if="selected_point">
                        <collapsible style="border-bottom: 1px solid black;" v-model="collapsible">
                            <template v-slot:caption>
                                Всі носії цього власника 
                                <b style="margin-left: 1.5em;"><span class="active">{{ distributor_stats.active }}</span> | <span class="inactive">{{distributor_stats.inactive}}</span></b>
                                <!-- <help-popup 
                                    :data-tippy-content="`
                                    (<span style='color: ${colors.inactive};'>прострочено</span> № 
                                    <span style='color: ${colors.active};'>не прострочено</span>) цим власником`"/> -->
                            </template>
                            
                            <li :class="`tiny-text collapsible-item ${item.properties.idx === selected_point.properties.idx ? 'selected': ''}`" 
                                v-for="(item, index) in points_by_entity" 
                                :key="index"
                                @click="$refs.adsmapref.select_point(item)"
                            >
                                <span :class="`circle ${item.properties.active ? 'active' : 'inactive'}`" />
                                {{ item.properties.address }}
                            </li>
                        </collapsible>
                    </section>
                </div>
            </section>

            <section class="full-width grid infobox-container interactive-bg">
                <div class="content">
                    <info-box v-if="selected_point" :d="selected_point" :entity_index="entity_index"></info-box>
                    <div v-else>
                        <div class="alert-box">
                            <p style="text-align: center"> <img src="../assets/finger_up.png" style="width: 2em; vertical-align: middle;" />  Клікніть точку на карті щоб побачити інформацію про порушення </p>
                        </div>
                    </div>
                </div>
            </section>
            </template>
        </div>

        <div class="full-width grid">
            <section class="content text-w after-text" >
<p>Міська рада регулює розміщення рекламних конструкцій. Встановити новий рекламний щит, сітілайт або банер можна лише після отримання дозволу. А якщо конструкцію зводять на комунальній земельній ділянці, слід додатково укласти договір оренди.</p>
<p>Якщо рекламний засіб не відображений на карті або має занедбаний вигляд, його тип та розміри не відповідають вказаним у дозволі, слід повідомити в Управління містобудування та архітектури</p>
                <div class="alert-box"> 
                    <p>
Якщо рекламний засіб не відображений на карті або має занедбаний вигляд, його тип та розміри не відповідають вказаним у дозволі, слід повідомити в Управління містобудування та архітектури (площа Соборна, 2, каб. 60-62, тел. <a href="tel:+3806262-2-51-41">06262 2-51-41</a>, <a href="tel:+38062-2-14-00">06262 2-14-00</a>, <a href="mailto:slavgorarch@i.ua"> slavgorarch@i.ua </a>). Можливо, рекламний засіб встановлений незаконно.
                    </p>
                </div>
            </section>            
        </div>
    </Tab>
</template>


<script>
import Tab from './Tab';
import PointsMap from '../components/PointsMap'
import InfoBox from '../components/ads/InfoBox'
import Collapsible from '../components/Collapsible'
import KnownHeightBlock from '../components/KnownHeightBlock'
import TopChart from '../components/TopChart'
import Checkbox from '../components/other/Checkbox'
import HelpPopup from '../components/other/HelpPopup'
import InfoSpoiler from '../components/other/InfoSpoiler'
import RotateYourPhone from '../components/other/rotate/RotateYourPhone'
import { create_index } from '../utils'

import * as d3 from 'd3'
import * as d3_array from 'd3-array'

import check_edrpou from '../check_edrpou'

const colors = {
    active: "#608FCB",
    inactive: "#AB328A",
}

const top_size = 10;

export default {
    name: "ads-tab",

    components: {
        Tab,
        PointsMap,
        InfoBox,
        Collapsible,
        KnownHeightBlock,
        TopChart,
        Checkbox,
        HelpPopup,
        InfoSpoiler,
        RotateYourPhone,
    },

    data() {
        return {
            points: null,
            selected_point: null,
            entity_index: null,
            stats: null,

            show_active: true,
            show_inactive: true,
            buffer_height: 0,

            top_data: null,

            collapsible: true,
            landscape: true,
        }
    },

    mounted() {
        this.loadData()
    },

    created() {
        this.colors = colors;
    },

    computed: {
        map_data() {
            return this.points.filter(d => 
                (d.properties.active && this.show_active) 
               || 
                (!d.properties.active && this.show_inactive)
            )
        },

        points_by_entity: function(){
            return this.entity_index
                .get(this.selected_point.properties.distributorName)
        },   

        distributor_stats() {
            let ads = this.entity_index.get(this.selected_point.properties.distributorName)

            var active = 0;
            var inactive = 0;

            ads.forEach(ad => {
                if (ad.properties.active) active++;
                else inactive++
            })

            return {
                active, inactive
            }
        }, 
        
        cssVars() {
            let res = {}

            for (const [k, value] of Object.entries(colors)) {
                res[`--col-${k}`] = value;
            }
            return res;
        },

        address_search_index() {
            return Array.from(this.address_index, ([key, value]) => ({ text: key || "не вказано", term: (key || "не вказано").toLowerCase(), p: value[0] }))
        }
    },

    methods: {
        async loadData() {
            var data = await d3.csv('data/ads.csv')
            
            data.forEach((d, idx) => {
                for (const key in d) {
                    if (d[key] === "null")
                        d[key] = null
                }
                d.idx = idx
                d.active = active(d.status)

                d.distributorIdentifier = check_edrpou(d.distributorIdentifier)

                d.address = `${d.addressThoroughfare} ${d.addressLocatorDesignator}`

            })

            this.points = to_geojson(data);
            this.entity_index = d3_array
                .rollup(this.points, v => v, d => d.properties.distributorName)

            let grouped = d3_array
                .rollup(
                    this.points, 
                    v => ({
                        active: v.filter(el => el.properties.active).length, 
                        total: v.length
                    }), 
                    d => d.properties.distributorName
                )

            this.top_data = Array.from(grouped.entries())
                .map(o => ({key: o[0], params: o[1]}) )
                .sort((o1, o2) => o2.params.total - o1.params.total)
                .slice(0, top_size)

            this.stats = d3_array
                .rollup(this.points, v => v.length, d => d.properties.active);


            this.address_index = create_index(
                this.points,
                d => d.properties.address,
                // d3.descending,
                // d => d.properties.date
            )
        },

        change_point_selected(point) {
            this.selected_point = point
        },   

        points_style(feature) {
            return {
                radius: 3,
                fillColor: feature.properties.active ? colors.active : colors.inactive,
                color: "#000",
                weight: 1,
                opacity: 1,
                fillOpacity: 0.65,
                stroke: 0
            };
        },


    }
}



function to_geojson(data) {
    return data.map(function(d) {
        return {
            type: "Feature",
            properties: d,
            geometry: {
                type: "Point",
                coordinates: [ d.geoCoordinatesLongitude, d.geoCoordinatesLatitude ]
            }
        };
    });
}

function active(status){
    if (!status || !status.length) return false;
    if (status.toUpperCase().trim() === "ЧИННИЙ") return true;
    return false
}

</script>

<style lang="scss" scoped>

$col-active: var(--col-active);
$col-inactive: var(--col-inactive);

.active {
    color: var(--col-active);
}

.inactive {
    color: var(--col-inactive);
}


.map-and-filters{
    display: grid;
    grid-template-columns: 6fr 3fr;


    .filters-container {
        padding: 1rem;
        background-color: var(--col-interactive-bg);   

        .buttons {
            margin-bottom: 1.5em;
            display: flex;
            gap: 3em;

            // /deep/ .style-active {
            //     button {
            //         background-color: $col-active;
            //         color: white;

            //         &.inactive {
            //             background-color: unset;
            //             border: 1px solid black;
            //             color: black;
            //         }
            //     }
            // }

            // /deep/ .style-inactive {
            //     button {
            //         background-color: var(--col-inactive);
            //     }
            // }

            // /deep/ button.inactive {
            //     background-color: unset;
            //     border: 1px solid black;
            //     color: black;
            // }           
            // justify-content: space-between;
        }
    }
}

.infobox-container {
    padding: 3em 0;
}

.after-text {
    margin: 4em 0;
}

/deep/ .content-inner {
    // border: 1px solid $col-sec;
    border-top: none;
}

.collapsible-item {
    display: flex;
    margin-bottom: 0.3em;
    cursor: pointer;
    font-weight: 300;

    &:hover {
        font-weight: bold;
    }

    .circle {
        display: table;
        width: 0.7em;
        height: 0.7em;
        border-radius: 50%;
        margin-top: 0.35em;
        margin-right: 0.3em;

        &.active {background-color: var(--col-active)};
        &.inactive {background-color: var(--col-inactive)};
    }

    &.selected {
        font-weight: 500;
    }

    // &.active {
    //     color: var(--col-active);
    // }

    // &.inactive {
    //     color: var(--col-inactive);
    // }
}

// This is inactivated button, not color for inactive point!!!!
// button.inactive {
//     background-color: #ccc !important;
// }   

.topchart-caption {
    margin-bottom: 1em;
}

// .topchart-section {
    // display: flex;
    // justify-content: space-between;
// }

/deep/ .topbarchart {
    width: 100%;
    max-width: 44em;
    min-width: 20em;
    font-size: 16px;
    
    .row {
        .param.param-total {
            background-color: $col-inactive;
            z-index: 10;
        }

        .param.param-active {
            background-color: $col-active;
            z-index: 11;
            color: white;
        }
    }

    .param, .caption {
        cursor: initial;
    }

    // .row:hover {
    //     .param.param-active {
    //         background-color: white; 
    //         color: black; 
    //         border: 1px solid black;
    //     }
        // .param.param-active {background-color: $col-main;}
    // }
}

/deep/ .info-spoiler {
    background: white;

    h6 {
        margin-bottom: 0;
    }
}

</style>

